import { GridItem } from '@bnnvara/grids';
import React from 'react';

import LikeButton from '../components/LikeButton';

const ComposableLikeButton = (props) => (
  <GridItem
    columnStartSm="1"
    columnEndSm="span 12"
    columnStartMd="2"
    columnEndMd="span 10"
    columnStartLg="3"
    columnEndLg="11"
    html
  >
    <LikeButton {...props} />
  </GridItem>
);

export default ComposableLikeButton;
